import React from 'react';



function OneSlider() {

  return (
	  <section className="slider-area slider-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-9">
              <div className="slider-content text-center">
                <h6 className="wow fadeInDown" data-wow-delay=".2s">islands</h6>
                <h2 className="tlt fix" data-in-effect="fadeInLeft">hunter <span>killer</span></h2>
                <p className="wow fadeInUp" data-wow-delay="2s">Find technology or people for digital projects in public sector and Find an individual specialist develope researcher.</p>
                <a href="/#" className="btn wow fadeInUp" data-wow-delay="2.2s">READ MORE</a>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default OneSlider;
